/**
 * Category Settings API
 * Manages category enable/disable and category-level permissions
 * Uses centralized apiClient for automatic auth handling
 */

import apiClient from '../utils/apiClient';

/**
 * Get all categories for a family (including disabled ones for admins)
 */
export const fetchFamilyCategories = async (familyId, includeDisabled = false) => {
  const params = includeDisabled ? '?include_disabled=true' : '';
  return apiClient.request(`/v1/families/${familyId}/categories${params}`);
};

/**
 * Update category (enable/disable)
 */
export const updateCategory = async (categoryId, isEnabled) => {
  return apiClient.request(`/v1/categories/${categoryId}`, {
    method: 'PATCH',
    body: JSON.stringify({ is_enabled: isEnabled }),
  });
};

/**
 * Get category-specific permissions (users with access to this category)
 */
export const fetchCategoryPermissions = async (categoryId) => {
  return apiClient.request(`/v1/categories/${categoryId}/permissions`);
};

/**
 * Grant or update category permission for a user
 */
export const grantCategoryPermission = async (categoryId, userEmail, accessLevel) => {
  return apiClient.request(`/v1/categories/${categoryId}/permissions`, {
    method: 'POST',
    body: JSON.stringify({
      user_email: userEmail,
      access: accessLevel
    }),
  });
};

/**
 * Revoke category permission from a user
 */
export const revokeCategoryPermission = async (categoryId, userId) => {
  return apiClient.request(`/v1/categories/${categoryId}/permissions/${userId}`, {
    method: 'DELETE',
  });
};

